import { render, staticRenderFns } from "./MessageThreadsEmptyView.vue?vue&type=template&id=1986eb92&functional=true&"
import script from "./MessageThreadsEmptyView.vue?vue&type=script&lang=ts&"
export * from "./MessageThreadsEmptyView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports